import React from 'react'
import Button from '../../../components/Button'
import Dialog from '../../../components/Dialog'
import { Box, Typography } from '@mui/material'

const RecalculateDialog = ({ onClose, open, onSave, startDate, endDate }) => {
  return (
    <Dialog
      width={496}
      height={144}
      open={open}
      onClose={onClose}
      showDialogFooter
      title='Recalculate Penalty'
      buttonAction={
        <Box display={'flex'} gap={3}>
          <Button text='Cancel' variant='outlined' onClick={onClose} />
          <Button text='Recalculate' color='success' onClick={onSave} />
        </Box>
      }
    >
      <Box p={4}>
        <Typography my={1} variant='body1'>
          {`THIS ACTION WILL RECALCULATE PENALTY FROM ${startDate} to ${endDate}`}
        </Typography>
        <Typography variant='body1'>
          Are you sure you want to Proceed?
        </Typography>
      </Box>
    </Dialog>
  )
}

export default RecalculateDialog
